define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 物体沿路径运动模式。
     *
     * @exports EnumPathPlayMode
     * 
     * @see Path#playMode
     */
    var EnumPathPlayMode = {
        /**
         * 一次。
         * @type {Number}
         * @constant
         */
        ONCE: 0,

        /**
         * 从起始点重复，1->2->1->2...。
         * @type {Number}
         * @constant
         */
        REPEAT: 1,

        /**
         * 来回往复,1->2->1->2...。
         * @type {Number}
         * @constant
         */
        LOOP: 2
    }
    freezeObject(EnumPathPlayMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumPathPlayMode) {
            if (EnumPathPlayMode.hasOwnProperty(key) && EnumPathPlayMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        ONCE: 0,
        REPEAT: 1,
        LOOP: 2,
        getName: getName
    }
})